import styled from "@emotion/styled";
import { Modal, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import EditIcon from "../../assets/icons/edit_icon";
import { Strings } from "../../i18n";
import SkillsArray from "../../mainTabs/profile/SkillsArray";
import SkillsScreen from "../../mainTabs/profile/SkillsScreen";
import { useAppSelector } from "../../redux/hooks";
import { AppColors } from "../../theme/AppTheme";
import ProfileSectionHeader from "./ProfileSectionHeader";

const StyledColumn = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '80px',
}));

const ProfileSkillsSection = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const isMobile = useAppSelector(store => store.appState.isMobile);
    const user = useAppSelector(store => store.userState.currentUser);

    const onEditPressed = () => {
        setOpen(true);
    }

    const stacked = isMobile;

    return (
        <StyledColumn>
            <ProfileSectionHeader title={'Professional Skills'} icon={<EditIcon />} action={t(Strings.edit)} onActionPressed={onEditPressed} />
            <div key={'skills-section'} style={{ display: 'flex', flexDirection: `${stacked ? 'column' : 'row'}`, alignItems: 'flex-start', justifyContent: 'flex-start', paddingTop: isMobile ? '25px' : '40px' }}>
                <Typography variant="h4" style={{ textAlign: 'left', width: stacked ? '100%' : isMobile ? '100px' : '200px', minWidth: isMobile ? '100px' : '200px' }}>
                    Skills & Keywords:
                </Typography>
                <Typography variant="subtitle2" style={{ marginTop: stacked ? '15px' : 0, lineHeight: '30px', textAlign: 'left', paddingLeft: stacked ? 0 : isMobile ? 'clamp(24px, 60px, 140px)' : 'clamp(40px, 140px, 140px)', color: AppColors.grey.darkish }}>
                    <SkillsArray emptyStateText="" skills={user?.info?.skills ?? []} title='' allSelected={false} />
                </Typography>
            </div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="edit-skills"
                aria-describedby="edit-skills-info"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <SkillsScreen onClose={() => setOpen(false)} />
            </Modal>
        </StyledColumn>
    )
}

export default ProfileSkillsSection